/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';
import { UpdateDashboardRequest } from '../../models/update-dashboard-request';

export interface DashboardsDashboardIdPut$Json$Params {
  dashboardId: string;
      body?: UpdateDashboardRequest
}

export function dashboardsDashboardIdPut$Json(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsDashboardIdPut$Json.PATH = '/dashboards/{dashboardId}';
